module.exports = __webpack_public_path__ + "img/icon_PDF@3x.6fb2dc42.png";